import { render, staticRenderFns } from "./HealthLeadForm.vue?vue&type=template&id=1222ac4e&"
import script from "./HealthLeadForm.vue?vue&type=script&lang=js&"
export * from "./HealthLeadForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports